var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85398 4.64598C5.90054 4.69242 5.93748 4.7476 5.96269 4.80834C5.9879 4.86909 6.00087 4.93421 6.00087 4.99998C6.00087 5.06575 5.9879 5.13087 5.96269 5.19161C5.93748 5.25236 5.90054 5.30753 5.85398 5.35398L3.20698 7.99998L5.85398 10.646C5.90047 10.6925 5.93734 10.7477 5.9625 10.8084C5.98766 10.8691 6.00061 10.9342 6.00061 11C6.00061 11.0657 5.98766 11.1308 5.9625 11.1916C5.93734 11.2523 5.90047 11.3075 5.85398 11.354C5.80749 11.4005 5.7523 11.4373 5.69156 11.4625C5.63082 11.4877 5.56572 11.5006 5.49998 11.5006C5.43423 11.5006 5.36913 11.4877 5.30839 11.4625C5.24766 11.4373 5.19247 11.4005 5.14598 11.354L2.14598 8.35398C2.09941 8.30753 2.06247 8.25236 2.03727 8.19161C2.01206 8.13087 1.99908 8.06575 1.99908 7.99998C1.99908 7.93421 2.01206 7.86909 2.03727 7.80834C2.06247 7.7476 2.09941 7.69242 2.14598 7.64598L5.14598 4.64598C5.19242 4.59941 5.2476 4.56247 5.30834 4.53727C5.36909 4.51206 5.43421 4.49908 5.49998 4.49908C5.56575 4.49908 5.63087 4.51206 5.69161 4.53727C5.75236 4.56247 5.80753 4.59941 5.85398 4.64598Z",
    fill: "#007BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 8C2.5 7.86739 2.55268 7.74021 2.64645 7.64645C2.74021 7.55268 2.86739 7.5 3 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H3C2.86739 8.5 2.74021 8.44732 2.64645 8.35355C2.55268 8.25979 2.5 8.13261 2.5 8Z",
    fill: "#007BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/Arrow left.67508bef32aada5dd100569b97e8f6a1.svg";
export { ForwardRef as ReactComponent };